<template>
  <map-loader
    :map-config="mapConfig"
  >
    <template v-for="(marker, index) in markers">
      <map-marker
        :key="index"
        :position="marker"
      />
    </template>
  </map-loader>
</template>

<script>
import MapLoader from './MapLoader.vue';
import MapMarker from './MapMarker.vue';

export default {
  props: {
    mapName: {
      type: String,
    },
    markers: {
      type: Array,
    },
  },
  data() {
    return {
      mapConfig: {
        zoom: 12,
        center: this.markers[0],
      },
    };
  },
  components: {
    MapLoader,
    MapMarker,
  },
};
</script>
